module.exports = __webpack_public_path__ + "img/icon-capitalist-usa.523c679d.svg";